import { Colors } from '../../colors';
import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const CorporateLine = ({ width = 18, height = 18, fill = Colors.gray700, ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.97441 15.4329C2.31167 15.4329 1.77441 14.8956 1.77441 14.2329V3.50786C1.77441 2.84512 2.31167 2.30786 2.97441 2.30786H7.69923C8.36197 2.30786 8.89923 2.84512 8.89923 3.50786V5.30786H15.0262C15.6889 5.30786 16.2262 5.84512 16.2262 6.50786V14.2329C16.2262 14.8956 15.6889 15.4329 15.0262 15.4329H2.97441ZM2.89923 14.3079H7.77441V12.4329H2.89923V14.3079ZM2.89923 11.3079H7.77441V9.43286H2.89923V11.3079ZM2.89923 8.30786H7.77441V6.43286H2.89923V8.30786ZM2.89923 5.30786H7.77441V3.43286H2.89923V5.30786ZM8.89923 14.3079H15.1014V6.43286H8.89923V14.3079ZM11.1061 9.43286C10.7954 9.43286 10.5436 9.18102 10.5436 8.87036V8.87036C10.5436 8.5597 10.7954 8.30786 11.1061 8.30786H12.7503C13.0609 8.30786 13.3128 8.5597 13.3128 8.87036V8.87036C13.3128 9.18102 13.0609 9.43286 12.7503 9.43286H11.1061ZM11.1061 12.4329C10.7954 12.4329 10.5436 12.181 10.5436 11.8704V11.8704C10.5436 11.5597 10.7954 11.3079 11.1061 11.3079H12.7503C13.0609 11.3079 13.3128 11.5597 13.3128 11.8704V11.8704C13.3128 12.181 13.0609 12.4329 12.7503 12.4329H11.1061Z"
        fill={fill}
      />
    </Svg>
  );
};

export default CorporateLine;
